module.exports = __webpack_public_path__ + "statics/img/image3.b499922f.png";